/** A freshly loaded source rests at 0 before the user has played or sought anything, so the fragment at 0 isn't current yet. */
export function checkHasPlayhead(
  nativeAudio: HTMLAudioElement,
  hasRequestedPosition: boolean,
): boolean {
  return (
    hasRequestedPosition ||
    nativeAudio.currentTime > 0 ||
    nativeAudio.played.length > 0
  );
}
